/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_ReratingInputs */

const en_orders_rerating = /** @type {(inputs: Orders_ReratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rerating...`)
};

const es_orders_rerating = /** @type {(inputs: Orders_ReratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recalculando...`)
};

/**
* | output |
* | --- |
* | "Rerating..." |
*
* @param {Orders_ReratingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_rerating = /** @type {((inputs?: Orders_ReratingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_ReratingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_rerating(inputs)
	return es_orders_rerating(inputs)
});